import { render, staticRenderFns } from "./EditUnitWorkUnitModal.vue?vue&type=template&id=2710e27c"
import script from "./EditUnitWorkUnitModal.vue?vue&type=script&lang=js"
export * from "./EditUnitWorkUnitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports